/* ============================================================
   dr.GUT — Levar o checkout para a Yampi

   O snippet da Yampi (snippets/YampiSnippet.liquid) só age em UMA
   página: a /cart. Todo o resto do que ele faz está atrás de
   `if (window.$ || window.jQuery)`, e este tema não carrega jQuery —
   esses trechos nunca rodam.

   Só que nesta loja ninguém passa pela /cart: o botão do drawer é um
   submit `name="checkout"` do formulário do carrinho, que a Shopify
   manda direto para o /checkout dela. O cliente saía do drawer para o
   checkout da Shopify sem nunca cruzar a única página onde a Yampi
   estaria esperando. Por isso a integração parecia desligada estando
   ativa.

   Aqui os caminhos de compra passam a apontar para /cart. De lá quem
   assume é o próprio snippet da Yampi, que com skip_cart ligado limpa
   o carrinho da Shopify e redireciona para o checkout dela.

   O status é consultado uma vez por sessão: se a Yampi for desativada
   ou desinstalada, este arquivo para de agir sozinho e a loja volta ao
   checkout da Shopify sem precisar de nenhuma mudança no tema.
   ============================================================ */
(function () {
  'use strict';

  var CHAVE = 'drgutYampiAtiva';
  var STATUS = 'https://api.dooki.com.br/v2/public/shopify/status?shop=';

  /* Na própria /cart quem manda é o snippet da Yampi. */
  if (window.location.pathname.indexOf('/cart') === 0) return;

  /* null = ainda não se sabe. */
  var ativa = null;
  try {
    var salvo = sessionStorage.getItem(CHAVE);
    if (salvo !== null) ativa = salvo === '1';
  } catch (e) {}

  if (ativa === null && window.fetch) {
    fetch(STATUS + window.location.host)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        ativa = !!(d && d.data && d.data.active);
        try { sessionStorage.setItem(CHAVE, ativa ? '1' : '0'); } catch (e) {}
      })
      .catch(function () {});
  }

  var ALVOS = [
    '[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    'a[href="/a/checkout"]'
  ].join(',');

  document.addEventListener(
    'click',
    function (e) {
      /* Enquanto a resposta não chega, o clique segue para /cart do
         mesmo jeito: essa página funciona com ou sem Yampi — no pior
         caso é um passo a mais, nunca uma compra perdida. Só quando se
         sabe que a Yampi está fora é que o clique passa direto. */
      if (ativa === false) return;

      var alvo = e.target.closest && e.target.closest(ALVOS);
      if (!alvo) return;
      if (alvo.disabled || alvo.getAttribute('aria-disabled') === 'true') return;

      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/cart';
    },
    /* Captura: o submit do formulário do carrinho precisa ser barrado
       antes de qualquer outro ouvinte do tema. */
    true
  );
})();
